// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  Form State
// -------------------------------
export interface FormState extends EntityState<any> {
  common?: any;
  form?: Array<any>;
}

// -------------------------------
//  Form Adapter
// -------------------------------
export const FormAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Form Initial State
// -------------------------------
export const initialState: FormState = FormAdapter.getInitialState(
  {
    common: null,
    form: [],
  },
);
